import { render, staticRenderFns } from "./BuyPoint.vue?vue&type=template&id=c4dcb172&scoped=true&"
import script from "./BuyPoint.vue?vue&type=script&lang=js&"
export * from "./BuyPoint.vue?vue&type=script&lang=js&"
import style0 from "./BuyPoint.vue?vue&type=style&index=0&id=c4dcb172&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4dcb172",
  null
  
)

export default component.exports